/**
 * The conversation design principles 2.0 is built on. Patterns 2.0 sets them
 * out, and the onboarding walkthrough lists them under its research.
 */
export const conversationPrinciples: { name: string; text: string }[] = [
  {
    name: 'Be upfront.',
    text: "We say what we do and how we use AI before asking anything. I'd rather not takes them to the old onboarding.",
  },
  {
    name: 'One thing at a time.',
    text: 'One question per message. The pinned checklist and See options keep the rest out of the way.',
  },
  {
    name: 'Their way of answering.',
    text: 'Voice or text, with captions if they want them. Chips are shortcuts, never the only way to reply.',
  },
  {
    name: 'Say it back.',
    text: "We summarise what we heard and ask if it's right before acting on it.",
  },
  {
    name: 'Easy to correct.',
    text: 'They fix the summary by saying or typing it. What they said stays read only.',
  },
  {
    name: "Only ask what's missing.",
    text: 'Questions after the summary cover what it left out, not what they already told us.',
  },
  {
    name: "They decide when it's done.",
    text: 'The turn ends when they confirm the summary, not when they send. Answered questions fold to the one they picked.',
  },
];
